import EstateEditorModal from './EstateEditorModal.container'
export default EstateEditorModal
